export function getView(hasSignature) {
  return hasSignature === null
    ? 'No'
    : hasSignature
    ? 'RequestAction'
    : 'AddAction'
}
